<script setup>
import {
  computed,
  toRefs,
} from 'vue';
import ImageComponent from '@/components/common/ImageComponent.vue';

const props = defineProps({
  emphasizeType: {
    type: String,
    default: '',
  },
  itemList: {
    type: Array,
    default: () => ([]),
  },
  header: {
    type: String,
    default: '',
  },
  highlight: {
    type: Object,
    default: () => ({}),
  },
  summary: {
    type: Object,
    default: () => ({}),
  },
});

const {
  highlight,
  itemList,
} = toRefs(props);

// 하이라이트 디스크립션
// 최대 19자(1줄)
// (썸네일) 최대 13자(1줄) 1줄 초과 시 말줄임 처리
const highlightContent = computed(() => {
  const text = highlight.value?.description || '';
  const imageId = highlight.value?.imageId || '';

  if (imageId) {
    const { length } = text;

    if (length > 13) {
      return `${text.slice(0, 13)}...`;
    }
  }

  return text;
});

// 하이라이트 타이틀
// 최대 30자(2줄) 1줄은 15자 입력가능
// (썸네일) 최대 21자(2줄) 1줄은 10자 입력가능 2줄 초과 시 말줄임 처리
const highlightTitle = computed(() => {
  let text = highlight.value?.title || '';
  const imageId = highlight.value?.imageId || '';

  if (text.endsWith('#{ }')) {
    text = text.slice(0, text.length - 4);
  }

  const { length } = text;

  if (imageId) {
    if (length > 20) {
      return `${text.slice(0, 10)}\n${text.slice(10, 20)}...`;
    }

    if (length > 10) {
      return `${text.slice(0, 10)}\n${text.slice(10, 20)}`;
    }

    return text;
  }

  if (length > 15) {
    return `${text.slice(0, 15)}\n${text.slice(15)}`;
  }

  return text;
});

// itemListHighlightTitleThrough
const itemListHighlightTitleThrough = computed(() => (highlight.value?.title || '').endsWith('#{ }'));

// 2줄 초과 시 말줄임 처리됩니다.
const displayItemList = computed(() => itemList.value.map((item) => {
  const {
    title,
    description,
  } = item;

  const temp = (description || '').split('\n');
  const descriptionList = temp.splice(0, 2);

  if (temp.length) {
    descriptionList[1] = `${descriptionList[1]}...`;
  }

  return {
    title,
    description: descriptionList.join('\n'),
  };
}));

</script>
<template>
  <div :class="{ 'd-none': emphasizeType !== 'ITEM_LIST' }">
    <div
      class="preview-message__inner-header"
      :class="{ 'd-none': !header }"
    >
      {{ header }}
    </div>
    <div
      class="preview-message__inner-tit"
      :class="{
        'd-none': !highlight?.title,
        topline: header,
      }"
    >
      <div class="preview-message__inner-tit-textwrap">
        <div
          class="preview-message__inner-tit-main"
          :class="{ 'line-through': itemListHighlightTitleThrough }"
        >
          {{ highlightTitle }}
        </div>
        <div class="preview-message__inner-tit-sub">
          {{ highlightContent }}
        </div>
      </div>
      <div
        class="preview-message__inner-tit-imgwrap"
        :class="{ 'd-none': !highlight?.image?.url }"
      >
        <div>
          <ImageComponent
            :src="highlight?.image?.url"
            alt="highlight-image"
          />
        </div>
      </div>
    </div>
    <div
      class="preview-message__inner-list item-list__text"
      :class="{ 'item-list__text--flex-start': !summary?.title }"
    >
      <p
        v-for="(item, index) in displayItemList"
        :key="`alimtalk-item-list-${index}`"
        :class="{ 'item-list__text--flex-start': !summary?.title }"
      >
        <span>{{ item.title }}</span><b>{{ item.description }}</b>
      </p>
    </div>
    <div
      class="preview-message__inner-list underline"
      :class="{ 'd-none': !summary?.title }"
    >
      <p>
        <span>{{ summary?.title }}</span>
        <b class="w60">{{ summary?.description }}</b>
      </p>
    </div>
  </div>
</template>
<style scoped>
.line-through {
  text-decoration: line-through;
}
</style>
